// extracted by mini-css-extract-plugin
module.exports = {"description":"SaveSearchModal_description__73QO7"};